import React from 'react';


const Linkedin = () => {
    const handleClick = () => {
        window.open('https://www.linkedin.com/in/nathanlee0630/', '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className="w-12 h-12 bg-contain bg-no-repeat bg-center hover:scale-110 transition-opacity dark:invert"
            style={{ backgroundImage: "url('/linkedin.svg')" }}
            aria-label="linkedin"
        />
    );
};

export default Linkedin;
